import { AstNodeCategory, AstNodeType } from './node';
export class LetStatement {
    constructor(_token, _name, _value, _isRef = false, _isAnchor = false) {
        this._token = _token;
        this._name = _name;
        this._value = _value;
        this._isRef = _isRef;
        this._isAnchor = _isAnchor;
        this.nodeType = AstNodeType.LetStatement;
        this.nodeCategory = AstNodeCategory.Statement;
    }
    get Token() {
        return this._token;
    }
    set Token(val) {
        this._token = val;
    }
    get Name() {
        return this._name;
    }
    set Name(val) {
        this._name = val;
    }
    get Value() {
        return this._value;
    }
    set Value(val) {
        this._value = val;
    }
    get IsRef() {
        return this._isRef;
    }
    set IsRef(val) {
        this._isRef = val;
    }
    set IsAnchor(val) {
        this._isAnchor = val;
    }
    get IsAnchor() {
        return this._isAnchor;
    }
    tokenLiteral() {
        var _a;
        return ((_a = this._token) === null || _a === void 0 ? void 0 : _a.literal) || '';
    }
    toString() {
        var _a, _b;
        let assignToken = '=';
        if (this._isRef) {
            assignToken = '&=';
        }
        if (this._isAnchor) {
            assignToken = '#=';
        }
        return `${this.tokenLiteral()} ${(_a = this.Name) === null || _a === void 0 ? void 0 : _a.toString()} ${assignToken} ${(_b = this.Value) === null || _b === void 0 ? void 0 : _b.toString()};`;
    }
}
//# sourceMappingURL=data:application/json;base64,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